import React, { Fragment, useContext } from 'react'

import Constants from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import ClickToOpenCardDark from '../../components/ClickToOpenCardDark.js'
import { Row } from "../../components/Row"
import SwitchSlider from '../../components/SwitchSlider.js'


/**
 * Blockchain Synchronization section (Electron only) — toggle whether the
 * wallet syncs with the blockchain or works from cache only.
 *
 * Props:
 *   - run: the Run instance (or null while loading)
 */
const SectionBlockchainSync = ({ run }) => {
	const userContext = useContext(UserContext)

	if (Constants.IS_WEB_BUILD) return null

	const clicked_update_disable_all_sync = () => {
		if (!run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}
		let newval = !userContext.disable_all_sync
		userContext.update_disable_all_sync(newval)
	}

	return (
		<Fragment>
			<ClickToOpenCardDark title="Blockchain Synchronization">
				<center><br />
					<div className="centered">
						En désactivant le bouton ci-dessous, vous pouvez désactiver les synchronisations.
						Votre wallet s'affichera uniquement à partir du cache local.
						Ce mode peut être utile si le wallet n'arrive pas à se connecter aux noeuds,
						car il permet malgré tout de continuer à pouvoir envoyer des transactions.
						<br /><br /><br />

						<Row style={{ display: "inline-block" }}>
							<SwitchSlider
								onChange={clicked_update_disable_all_sync}
								checked={!userContext.disable_all_sync}
							/>
							&nbsp;<i>Activate synchronizations</i>
						</Row>
						<br />
					</div>
				</center>
				<br />
			</ClickToOpenCardDark>
			<br />
		</Fragment>
	)
}

export default SectionBlockchainSync
